/*
 * Copyright (C) 2023 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Interceptor module for checking responses errors.
 */
angular
  .module('interceptor.expiredOrgError', [])
  /**
   * A factory that registers the interceptor logic.
   */
  .factory('expiredOrgErrorInterceptor', [
    '$q',
    '$rootScope',
    'ALERT_EVENTS',
    'HTTP_ERROR_STATUS',
    function ($q, $rootScope, ALERT_EVENTS, HTTP_ERROR_STATUS) {
      return {
        // On response failure
        responseError: function (rejection) {
          if (
            rejection.status === HTTP_ERROR_STATUS.FORBIDDEN &&
            rejection.data.reason === ALERT_EVENTS.EXPIRED_ORG.type
          ) {
            $rootScope.$emit(ALERT_EVENTS.EXPIRED_ORG.eventName);
          }
          return $q.reject(rejection);
        }
      };
    }
  ]);
